"use strict";
import { __require as o } from "./index.es303.js";
var e, r;
function O() {
  if (r) return e;
  r = 1;
  var t = /* @__PURE__ */ o();
  return e = t.getPrototypeOf || null, e;
}
export {
  O as __require
};
//# sourceMappingURL=index.es321.js.map
